/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagBaselineEnhanceRequest {
    getFixupPrototypeFunction() { return TagBaselineEnhanceRequest.fixupPrototype; }

    static newInstance(model: Partial<TagBaselineEnhanceRequest>): TagBaselineEnhanceRequest {
        let obj = Object.assign(new TagBaselineEnhanceRequest(), model);
        TagBaselineEnhanceRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagBaselineEnhanceRequest>): TagBaselineEnhanceRequest {
        if (!model) return null;
        return TagBaselineEnhanceRequest.newInstance(<TagBaselineEnhanceRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagBaselineEnhanceRequest) {
        if (!obj) return;

        models.TagBaselineEnhanceRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagBaselineEnhanceRequest): boolean {
        Object.setPrototypeOf(obj, TagBaselineEnhanceRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.tags_to_enhance) {
            for (let val of this.tags_to_enhance) {
                models.TagBaselineCustomTags.fixupPrototype(val);
            }
        }
    }

    /**
     * Tags to be enhanced
     */
    tags_to_enhance: Array<models.TagBaselineCustomTags>;

}
